import { Theme, withStyles, createStyles } from '@material-ui/core';

import getSpacingHelpers from '../../utils/getSpacingHelpers';

export const GlobalCss = withStyles((theme: Theme) => createStyles({
  '@global': {
    body: {
      backgroundColor: '#fefefe',
    },
    strong: {
      fontWeight: 700,
    },
    '.t-pos': {
      color: `${theme.palette.success.main} !important`,
    },
    '.t-neg': {
      color: `${theme.palette.error.main} !important`,
    },
    '.t-war': {
      color: `${theme.palette.warning.main} !important`,
    },
    '.t-nowrap': {
      whiteSpace: 'nowrap',
    },
    '.t-prewrap': {
      whiteSpace: 'pre-wrap',
    },
    '.t-mono': {
      fontFamily: 'monospace, sans-serif',
    },
    '.btn-pos-outlined, .btn-suc-outlined': {
      borderColor: theme.palette.success.main,
      color: theme.palette.success.main,
    },
    '.btn-neg-outlined, .btn-err-outlined': {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
    },
    '.btn-war-outlined': {
      borderColor: theme.palette.warning.main,
      color: theme.palette.warning.main,
    },
    '.MuiFormHelperText-root': {
      lineHeight: 1.1,
      marginTop: theme.spacing(1),
    },
    '@keyframes rotation': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
    // bootstrap like spacing helpers (mt-3, pl-5, etc...)
    ...getSpacingHelpers(theme),
    '.amo-button-holder': {
      display: 'none',
    },
    iframe: {
      pointerEvents: 'none',
    },
  },
}))(() => null);
